import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "vertical-center justify-content-center" }
const _hoisted_5 = { class: "col-sm-3" }
const _hoisted_6 = { class: "float-end" }
const _hoisted_7 = { class: "col-sm-9" }
const _hoisted_8 = { class: "container" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-4" }
const _hoisted_11 = { class: "small" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" T:")
const _hoisted_14 = {
  class: "visible-xs-inline",
  href: "tel:{{ phone }}}"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" E:")
const _hoisted_17 = { href: "mailto:{{ email }}" }
const _hoisted_18 = { class: "col-8" }
const _hoisted_19 = { class: "small" }
const _hoisted_20 = { class: "small" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Vue3Lottie = _resolveComponent("Vue3Lottie")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("header", null, [
          _createElementVNode("img", {
            src: _ctx.logo,
            alt: "Novia Financial logo"
          }, null, 8, _hoisted_3),
          _createElementVNode("h4", null, _toDisplayString(_ctx.strapline), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_Vue3Lottie, {
                animationData: _ctx.animationData,
                class: "lottie-animation"
              }, null, 8, ["animationData"])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("h1", null, _toDisplayString(_ctx.header), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.content), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("footer", null, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("p", _hoisted_11, [
              _createTextVNode(_toDisplayString(_ctx.copyright) + " ", 1),
              _hoisted_12,
              _hoisted_13,
              _createElementVNode("a", _hoisted_14, _toDisplayString(_ctx.phone), 1),
              _hoisted_15,
              _hoisted_16,
              _createElementVNode("a", _hoisted_17, _toDisplayString(_ctx.email), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.fcaRegistrationInformation), 1),
            _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.phoneCharges), 1)
          ])
        ])
      ])
    ])
  ], 64))
}